module.exports = __webpack_public_path__ + "static/media/shareGrey.71f21e1c.svg";